import log from 'salvo-lite/log'

class WishlistBack {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        if (!window.location.href.includes('#/wishlist')) {
            this._elem.style.display = 'none'
        } else {
            this._elem.style.display = 'inline-flex'
        }
        window.addEventListener('popstate', e => {
            if (!window.location.href.includes('#/wishlist')) {
                this._elem.style.display = 'none'
            } else {
                this._elem.style.display = 'inline-flex'
            }
        })
    }
}

export default WishlistBack



// WEBPACK FOOTER //
// ./src/resources/scripts/components/WishlistBack.js